import { useMemo } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'

import { PartnersWithoutSoBDialogContent } from './PartnersWithoutSoBDialogContent'

interface IProps {
  isShowDialog: boolean
  partnerIds: string
  onConfirm: () => void
  onClose: () => void
}

export const PartnersWithoutSoBDialog = ({
  isShowDialog,
  partnerIds,
  onConfirm,
  onClose,
}: IProps) => {
  const contentProps = useMemo(() => {
    return { partnerIds, onConfirm, onClose }
  }, [partnerIds, onConfirm, onClose])

  return (
    <ModalDialog
      size={'md'}
      show={isShowDialog}
      content={PartnersWithoutSoBDialogContent}
      contentProps={contentProps}
      onClose={onClose}
    />
  )
}
